// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__4814U","sidebar":"MainLayout_sidebar__W+okD","content":"MainLayout_content__uxekw"};